import { memo, useCallback } from 'react';
import { cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import { useDeps } from '@Contexts/DI';
import Img from '@UI/Img';
import FontAnton from '@Components/FontAnton';
import ButtonPillow from '@Pages/PageTytryadom/elements/ButtonPillow';
import image1 from './images/1.jpg';
import image2 from './images/2.jpg';
import styles from './ATRInfo.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface ATRInfoProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const ATRInfo: FC<ATRInfoProps> = (props) => {
  const { t } = useTranslation();
  const { analytics } = useDeps();

  const handleClick = useCallback(() => {
    analytics.dispatchEvent('link.antontut.click', { source: 'card' });
  }, [analytics]);

  return (
    <>
      <FontAnton />
      <div {...props}>
        <div className={styles.logos}>
          <div className={cn(styles.logo, { [styles.logoDivan]: true })} />
          <div className={styles.delimiter} />
          <div className={cn(styles.logo, { [styles.logoAnton]: true })} />
        </div>
        <div className={styles.text}>{t('atr.product-info')}</div>
        <div className={styles.grid}>
          <div className={styles.photos}>
            <Img src={image1} className={styles.photo} />
            <Img src={image2} className={styles.photo} />
          </div>
          <div>
            <div className={styles.infoTitle}>{t('atr.help')}</div>
            <div className={styles.infoText}>{t('atr.info')}</div>
            <ButtonPillow
              className={styles.link}
              link='/anton-tut-ryadom'
              target='_blank'
              onClick={handleClick}
            >
              {t('ui.more')}
            </ButtonPillow>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(ATRInfo);
